import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';
import { useTheme } from 'components/core/theme-provider';
import { cn } from 'lib/utils';

interface SidebarNavTooltipProps {
  label: string;
  enabled?: boolean;
  children: React.ReactElement;
}

export function SidebarNavTooltip({ label, enabled = true, children }: SidebarNavTooltipProps) {
  const { theme } = useTheme();
  const textColor = theme === 'dark' ? 'text-true-white' : 'text-grey-900';

  if (!enabled) {
    return children;
  }

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side="right"
        sideOffset={10}
        className={cn(
          'rounded-nav border border-grey-100 bg-true-white px-3 py-1.5 text-sm font-normal leading-heading shadow-primary-soft dark:border-sidebar-border dark:bg-sidebar',
          textColor
        )}
      >
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
